import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { environment } from './../../environments/environment';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs'
import { ForgotPassword } from '../../pages/forgot-password/forgot-password.model';
import { ResetPassword } from '../../pages/reset-password/reset-password.model';
import { JwtHelperService } from '@auth0/angular-jwt'

// ngrx/store
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers'

import * as UserActions from '../../actions/user.actions';
import * as CompaniesActions from '../../actions/companies.actions';


@Injectable()
export class Auth {

  authUser = new ReplaySubject<any>(1);
  authUserObject = new ReplaySubject<any>(1);

  private _isLoggedIn = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this._isLoggedIn.asObservable()

  private _isUser = new BehaviorSubject<any>({});
  isUser$ = this._isUser.asObservable()

  public user: any = {};
  public loggedIn: boolean = false;
  public token: string;
  public apiUrl: string = environment.API_ENDPOINT;
  private headers: HttpHeaders;
  constructor(
    private store: Store<fromRoot.State>,
    private readonly jwtHelper: JwtHelperService,
    private readonly authHttp: HttpClient,
    private readonly http: HttpClient
    , private readonly storage: Storage) {

    this.storage.get('token').then(res => {
      if (res) {
        this.token = res;
        this.loggedIn = true;
        this._isLoggedIn.next(true);
      } else {
        this.loggedIn = false;
      }
    });
    this.storage.get('user').then(res => {
      if (res) {
        this.user = res;
        this._isUser.next(res);
      } else {
      }
    });
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.API_KEY
    });

  }

  getUser() {
    return this.user;
  }

  forgotPassword(forgotPassword: ForgotPassword): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/forgotpassword`, forgotPassword, { headers: this.headers });
  }

  resetPassword(resetPassword: ResetPassword): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/resetpassword`, resetPassword, { headers: this.headers })
  }

  authenticated(): boolean {
    return this.loggedIn;
  }

  createAccount(details) {

    return new Promise((resolve, reject) => {

      this.http.post(`${this.apiUrl}auth/register`, JSON.stringify(details), { headers: this.headers })
        .subscribe(res => {

          let data = res;
          this.token = data['token'];
          this.storage.set('token', data['token']);
          resolve(data);

        }, (err) => {
          reject(err);
        });

    });

  }

  checkAuthentication() {

    return new Promise((resolve, reject) => {

      //Load token if exists
      this.storage.get('token').then((value) => {

        this.token = value;

        let headers = new HttpHeaders({
          'Authorization': this.token,
          'Content-Type': 'application/json',
          'x-api-key': environment.API_KEY
        });

        this.http.get(`${this.apiUrl}auth/protected`, { headers: headers })
          .subscribe(res => {
            resolve(res);
          }, (err) => {
            reject(err);
          });

      });

    });

  }

  checkLogin() {
    this.storage.get('jwt').then(jwt => {
    //Get local storage JWT if it exists and has not expired, otherwise emit null
    if (jwt && !this.jwtHelper.isTokenExpired(jwt)) {
        this.authHttp.get(`${this.apiUrl}auth/protected`, { headers: this.headers })
          .map(res => res)
          .subscribe(res => {
            //Get the user stored in local storage if it exists otherwise emit null
            this.storage.get('user').then(user => {
              if (!user) { this.storage.remove('jwt').then(() => this.authUser.next(null)) };
              //JWT present and USER present
              this.authUser.next(jwt);
              this.authUserObject.next(user);
              //Let the store know about it
              this.store.dispatch(new UserActions.LoginSuccess(user));
            });

          },
          (err) => this.storage.remove('jwt').then(() => this.authUser.next(null)))
      }
      else {
        this.storage.remove('jwt').then(() => this.authUser.next(null));
      }
    });
  }

  login(credentials: any): Observable<any> {
    return this.http.post(`${this.apiUrl}auth/login`, JSON.stringify(credentials), { headers: this.headers })
      // .map(res => res.json())
      .map(res => {this.handleJwtResponse(res['token']); return res})
      .map(res => {
        this.setUser(res['user']);
      })
  }

  getToken(): string {
    return this.token
  }

  logout() {
    this.setLoggedIn(false);
    this.store.dispatch(new UserActions.LogoutSuccess());
    this.store.dispatch(new CompaniesActions.Reset());
    this.setUser('');
    this.storage.clear().then(() => this.authUser.next(null));
  }

  setLoggedIn(value: boolean) {
    this._isLoggedIn.next(value)
    this.loggedIn = value;
  }

  setUser(user: any) {
    this.store.dispatch(new UserActions.LoginSuccess(user));

    //Just in case we get back body instead of user
    user = user.user? user.user : user;
    this._isUser.next(user)
    this.authUserObject.next(user);
    this.user = user;
    return this.storage.set('user', user);
  }

  private handleJwtResponse(jwt: string) {
    return this.storage.set('jwt', jwt)
      .then(() => this.authUser.next(jwt))
      .then(() => jwt);
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts